import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit, } from '@angular/core';
import { trigger, style, animate, transition, state, AnimateTimings } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { DataTransferService } from '../../../../services/DataTransferService';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debug } from 'console';



@Component({ 
    selector: 'receipts-mode',
    templateUrl: './mode.component.html',
    styleUrls: ['./mode.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                display: 'block'
            })),
            state('closed', style({
                opacity: 0,
                display: 'none'
            })),
            transition('open => closed', [
                animate('0.5s')
            ]),
            transition('closed => open', [
                animate('0.5s')
            ]),
        ]),
    ]
})
export class ModeComponent implements OnInit, OnChanges, AfterViewInit {
    isDropOffEnabled = false as boolean;
    ngAfterViewInit(): void {
        this.data.currentmode.subscribe(x => this.mode = x);
        if (this.mode != "default message" && this.mode != null) {
            this.selectMode(this.mode)
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['changing'] != undefined) {
            var change = changes['changing'].currentValue
            if (change == true)
                this.isOpen = true;
        }
    }
    @Output() modeObject = new EventEmitter();
    mode: any;
    @Input() initialValue;
    @Input() changing: boolean;
    modeSelected: boolean;
    isOpen: boolean = true;
    receiptTypes = [];
    selectedMode: string;
    isPackagingEnabled :boolean;
    @Input() enableChange: any;
    @Output() isEnableSelectProductGroup = new EventEmitter();
    @Output() isEnableSelectInboundAWB = new EventEmitter();
    @Output() isEnableSelectCategory = new EventEmitter();
    //adding packagin eventemitter to enable the packaging-awb component
    @Output() isEnableSelectPackaging = new EventEmitter();
    constructor(private receipt: ReceiptService, private data: DataTransferService, private router: Router, private translateService: TranslateService) {
        this.modeSelected = false;
    }
    selectMode(modeName,isClose?) {        
        this.selectedMode = modeName;
        this.modeObject.emit(modeName)
        this.modeSelected = true;
        this.isEnableSelectProductGroup.emit(true);
        this.isEnableSelectInboundAWB.emit(true);
        this.isEnableSelectCategory.emit(true);
        this.isEnableSelectPackaging.emit(true);
        this.isOpen = isClose ? !isClose : !this.isOpen;        
    }

    
    change() {
        this.isOpen = !this.isOpen;
        this.isEnableSelectProductGroup.emit(false);
        this.isEnableSelectInboundAWB.emit(false);
        this.isEnableSelectCategory.emit(false);
        this.isEnableSelectPackaging.emit(false);
    }


    getModeClassName(modeId) {
        var className = '';
        switch (modeId) {
            case 1:
                className = 'armx-inbound';
                break;
            case 3:
                className = 'armx-outbound';
                break;
            case 2:
                className = 'armx-misc';
                break;
            case 4:
                className = 'armx-dropbox';
                break;
            case 5:
                className = 'armx-cube';
                break;
        }
        return className;
    }

    getModeName(receipt) {
        switch (receipt.ReceiptTypeId) {
            case 1:
                return this.translateService.instant('common.inbound')
            case 2:
                return this.translateService.instant('common.outbound')
            case 3:
                return this.translateService.instant('common.misc')
            case 4:
                return this.translateService.instant('common.dropOff')
            case 5 : 
                return this.translateService.instant('common.packaging')
            default:
                return receipt.Description
        }
    }

    getInitalShipment() {
        return this.data.currentShipment;
    }
    ngOnInit() {
        var settings = JSON.parse(sessionStorage.getItem('branchSettings'));
        this.isDropOffEnabled = settings.filter(x => x.Key == 35)[0] != undefined ? (settings.filter(x => x.Key == 35)[0].Value) == 'True' : false;
        this.isPackagingEnabled = settings.filter(x => x.Key == 42)[0] != undefined ? (settings.filter(x => x.Key == 42)[0].Value) == 'True' : false;

        this.receipt.getReceiptTypes((res) => {
            this.receiptTypes = res;
            if (!this.isDropOffEnabled) {
                //this is to remove the DroppOff type if it's not enabled for the branch
                this.receiptTypes = this.receiptTypes.filter(x => x.ReceiptTypeId !== 4);
            }
            if (!this.isPackagingEnabled) {
                this.receiptTypes = this.receiptTypes.filter(x => x.ReceiptTypeId !== 5);
            }
        }, (err) => {
        });
    }
}
